import React from "react";

import "./LocaleButton.scss";

import { Say } from "../../../../arc/locale/consts.js";
import { usePagePop } from "../../PagePops/PagePops";
import { Locale } from "../../../assets/Locale";
import { LocaleFlag } from "../LocaleFlag/LocaleFlag";

export const LocaleButton = (props)=>{
    const { } = props;
    const localeForm = usePagePop("localeForm");
    const say = Locale.use();
    const localeId = Locale.useId();
    const label = say.or("localeFormCaption", "Upravit jazyk");
    const flagLabel = say.or(Say.id("locale", "form", "option", localeId), localeId?.toUpperCase());

    return (
        <button
            aria-label={label}
            className="LocaleButton"
            disabled={!localeForm}
            onClick={_=>localeForm?.up()}
            title={label}
            type="button"
        >
            <LocaleFlag label={flagLabel} locale={localeId}/>
            <span>{flagLabel}</span>
        </button>
    )
}
